// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/sigwx-charts.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/sigwx-charts/sigwx-charts.js';

mount([g0]);
